import apirecebimentoweb from '@/services/api-recebimentoweb';

export default {
  namespaced: true,

  state: {
    list: [],
    loading: false,
  },

  getters: {
    list: (state) => state.list,
    loading: (state) => state.loading,
  },

  // NUNCA ALTERAR state DIRETAMENTE EM ACTIONS
  actions: {
    async find(_, {
      where, ...params
    } = {}) {
      const [{ data }, { data: { count: total } }] = await Promise.all([
        apirecebimentoweb.get('movimentocaixa', { params: { ...where, ...params } }),
        apirecebimentoweb.get('movimentocaixa/count', { params: where }),
      ]);

      return { data, total };
    },

    async findById(_, { id }) {
      const { data } = await apirecebimentoweb.get(`movimentocaixa/${id}`);
      return data;
    },

    async findByTurnoId({ dispatch }, { idTurno, where = {}, ...params } = {}) {
      const queryWhere = {
        mocidturnovendas: idTurno,
        ...where,
      };

      const res = await dispatch('find', {
        where: queryWhere,
        orderBy: 'mocformadescricao asc',
        ...params,
      });

      return res;
    },
  },

  // APENAS O MUTATION FAZ ALTERAÇÕES NO STATE
  mutations: {
    SET_LIST(state, list) {
      state.list = list ?? [];
    },
    loading(state, request) {
      state.loading = request ?? false;
    },
  },
};
